'use strict';

var loadScript = require('./load').loadScript;
var prefixV1 = '//www.dpfile.com/app/dp-logan-web/logan_';
var prefixV2 = '//s3.meituan.net/v1/mss_eb9ea9cfff9840198c3ae909b17b4270/production/logan-websdk/logan_';
var Logan = void 0;
var enable = false;

module.exports = {
    queue: [],
    ready: function ready() {
        var _this = this;

        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var LoganAPI = config.LoganAPI,
            project = config.project,
            pageUrl = config.pageUrl,
            loganConfig = config.loganConfig,
            version = config.version;

        enable = true;

        var doTask = function doTask() {
            if (!Logan) return;
            if (loganConfig) Logan = Logan.config(loganConfig);

            Logan.log('[Session]:' + JSON.stringify({ project: project, pageUrl: pageUrl }), 'owl', 'info', ['session']);

            while (_this.queue.length) {
                Logan.log(_this.queue.shift(), 'owl');
            }
        };

        if (LoganAPI) {
            Logan = LoganAPI;
            doTask();
        } else {
            try {
                if (window.Logan) {
                    Logan = window.Logan;
                    doTask();
                } else {
                    var url = (version.indexOf('1.') === 0 ? prefixV1 : prefixV2) + version + '.js';
                    loadScript(url, function () {
                        Logan = window.Logan;
                        doTask();
                    });
                }
            } catch (e) {
                console.log('logan 加载失败');
            }
        }
    },
    log: function log(msg) {
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!enable) return;

        var type = opts.noType ? 'default' : 'owl';
        if (Logan) {
            Logan.log(msg, type);
        } else {
            this.queue.push(msg);
        }
    },
    _log: function _log() {
        try {
            if (Logan && Logan.log) {
                Logan.log.apply(Logan, arguments);
            }
        } catch (e) {}
    }
};